export default "__VITE_ASSET__DVDFhis8__"